import { createFileRoute } from "@tanstack/react-router";
import { PlansPage } from "@/features/admin-plans/PlansPage";

function Page() {
  const { session } = Route.useRouteContext();
  return <PlansPage actorId={session.user.id} />;
}
export const Route = createFileRoute("/_authenticated/_protected/_admin/admin/plans")({ component: Page });
